import React from 'react';
import styled from 'styled-components';

import HeaderSound from './HeadeSound/HeaderSound';
import headerImg from '../../assets/images/header.png';

const HeaderImage = styled.img`
    display: block;
    width: 100%;
    height: auto;
    min-height: 100vh;
    object-fit: cover;
`;
const HeaderVideo = styled.video`
    object-fit: cover;
    width: 100%;
    height: 100%;
`;
const HeaderWrapper = styled.section`
    width: 100vw;
    height: ${({video}) => video ===true ? "100vh" : "80vh"};
    overflow: hidden;
    object-fit: cover;
    max-height: 100vh;
`;

const Header = (props) => {
    const [muted, setMuted] = React.useState(true);
    return (        
        <HeaderWrapper video={props.video}>
            {props.video ? 
                <HeaderVideo autoPlay muted={muted} loop><source src={props.link}/>
                </HeaderVideo>
            : <HeaderImage src={props.link ? props.link.src : headerImg}/>}
            {props.video ? <HeaderSound clicked={() => setMuted(!muted)} mutedState={muted}/> : null}
        </HeaderWrapper>
    )
};

export default Header